import { fieldSchema } from './schema'

const UID_MENU = 'plugin::tree-menus.menu'
const UID_UPLOAD_FILE = 'plugin::upload.file'

const SINGLE_TYPES = 'single-types'
const COLLECTION_TYPES = 'collection-types'

export { UID_MENU, fieldSchema, UID_UPLOAD_FILE, SINGLE_TYPES, COLLECTION_TYPES }
